module.exports = __webpack_public_path__ + "static/media/Atmos_end.e7905dc3.mp4";